import React from 'react';
import Svg from '../Svg';

const IconAsterisk01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1C12.5523 1 13 1.44772 13 2V9.58578L18.364 4.22183C18.7545 3.8313 19.3876 3.8313 19.7782 4.22183C20.1687 4.61235 20.1687 5.24551 19.7782 5.63604L14.4142 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H14.4142L19.7782 18.364C20.1687 18.7545 20.1687 19.3876 19.7782 19.7782C19.3876 20.1687 18.7545 20.1687 18.364 19.7782L13 14.4142V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V14.4142L5.63604 19.7782C5.24551 20.1687 4.61235 20.1687 4.22183 19.7782C3.8313 19.3876 3.8313 18.7545 4.22183 18.364L9.58579 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H9.58578L4.22183 5.63604C3.8313 5.24551 3.8313 4.61235 4.22183 4.22183C4.61235 3.8313 5.24551 3.8313 5.63604 4.22183L11 9.58579V2C11 1.44772 11.4477 1 12 1Z"
    />
  </Svg>
);

export default IconAsterisk01;
